import textRegs from '../utils/textRegs';
export default {
  name: 'text',
  label: '单行文本',
  icon: 'el-icon-edit',
  config: [{
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请输入'
    }
  }, {
    // 可修改的配置选项
    xtype: 'select',
    options: {
      label: '文本格式',
      name: 'regex',
      default: '',
      options: textRegs
    }
  }, {
    // 可修改的配置选项
    xtype: 'number',
    options: {
      label: '最大长度限制',
      name: 'maxLength',
      default: 32,
      dataType: 'Number'
    }
  }, {
    xtype: 'default-option',
    options: {
      label: '默认值',
      name: 'defaultVal',
      placeholder: '设置表单默认值'
    }
  }]
};